import { ReactNode } from 'react';
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

type Props = {
  children: ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  fullWidth?: boolean;
  fullHeight?: boolean;
  formId?: string;
  autoComplete?: boolean;
};

export const FormProvider = ({ children, onSubmit, methods, fullWidth, fullHeight, formId, autoComplete }: Props) => {
  return (
    <Form {...methods}>
      <form
        style={{ width: fullWidth ? '100%' : 'unset', height: fullHeight ? '100%' : 'unset' }}
        id={formId}
        onSubmit={onSubmit}
        autoComplete={autoComplete ? 'on' : 'off'}
      >
        {children}
      </form>
    </Form>
  );
};

export default FormProvider;
